import { graphql } from 'gql';

export const bimcCalculationLimitedCostsGql = graphql(`
    query bimcCalculationLimitedCosts($skip: Int, $take: Int, $calculationId: Long!, $constructionTypeId: Int) {
        bimcCalculationLimitedCosts(
            skip: $skip
            take: $take
            calculationId: $calculationId
            constructionTypeId: $constructionTypeId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                calculationId
                rationale
                name
                key
                chapter
                calculatingValue
                formula
                hasFormulaError
                hasCalculatingParticipation
                isEditable
                isNorthernAllowance
                isManualLimitsDistribution
                globalLimitedCostId
                catalogLimitedCostTypeId
                seasonAmounts {
                    constructionTypeId
                    seasonId
                    cost
                }
            }
            totalCount
        }
    }
`);

export const bimcCalculationLimitedCostNameFilterGql = graphql(`
    query bimcCalculationLimitedCostNameFilter(
        $calculationId: Long!
        $constructionTypeId: Int
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        bimcCalculationLimitedCostNameFilter(
            calculationId: $calculationId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const bimcRemoveCalculationLimitedCostsGql = graphql(`
    mutation bimcRemoveCalculationLimitedCosts($calculationId: Long!, $ids: [Long!]!) {
        bimcRemoveCalculationLimitedCosts(calculationId: $calculationId, ids: $ids) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const bimcGlobalLimitedCostsForCalculationGql = graphql(`
    query bimcGlobalLimitedCostsForCalculation(
        $skip: Int
        $take: Int
        $calculationId: Long!
        $order: [GlobalLimitedCostDataSortInput!]
        $where: GlobalLimitedCostDataFilterInput
    ) {
        bimcGlobalLimitedCostsForCalculation(
            skip: $skip
            take: $take
            calculationId: $calculationId
            order: $order
            where: $where
        ) {
            items {
                id
                name
                methodology
                chapter
                section
                catalogLimitedCostType {
                    name
                    id
                    uniqueId
                }
                formula
                hasCalculatingParticipation
                isSystem
            }
        }
    }
`);

export const bimcCalculationLimitedCostTypesGql = graphql(`
    query bimcCalculationLimitedCostTypesQuery(
        $skip: Int
        $take: Int
        $calculationId: Long!
        $limitedCostId: Long
        $where: CatalogLimitedCostTypeDataFilterInput
        $order: [CatalogLimitedCostTypeDataSortInput!]
    ) {
        bimcCalculationLimitedCostTypes(
            skip: $skip
            take: $take
            calculationId: $calculationId
            limitedCostId: $limitedCostId
            where: $where
            order: $order
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                uniqueId
                name
            }
            totalCount
        }
    }
`);

export const bimcIsCalculationLimitedCostKeyUniqueGql = graphql(`
    query bimcIsCalculationLimitedCostCodeUnique($calculationId: Long!, $limitedCostId: Long, $key: String!) {
        bimcIsCalculationLimitedCostCodeUnique(
            calculationId: $calculationId
            limitedCostId: $limitedCostId
            key: $key
        ) {
            result
            isUnique: id
        }
    }
`);

export const bimcIsCalculationLimitedCostNameUniqueGql = graphql(`
    query bimcIsCalculationLimitedCostNameUnique($calculationId: Long!, $limitedCostId: Long, $name: String!) {
        bimcIsCalculationLimitedCostNameUnique(
            calculationId: $calculationId
            limitedCostId: $limitedCostId
            name: $name
        ) {
            result
            isUnique: id
        }
    }
`);

export const bimcCreateCalculationLimitedCostGql = graphql(`
    mutation bimcCreateCalculationLimitedCost($input: BimcCalculationLimitedCostInput!) {
        bimcCreateCalculationLimitedCost(input: $input) {
            id
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const bimcUpdateCalculationLimitedCostGql = graphql(`
    mutation bimcUpdateCalculationLimitedCost($id: Long!, $input: BimcCalculationLimitedCostInput!) {
        bimcUpdateCalculationLimitedCost(id: $id, input: $input) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            actionRequired
        }
    }
`);

export const bimcCalculationLimitedCostForUpdateGql = graphql(`
    query bimcCalculationLimitedCostForUpdate($calculationId: Long!, $limitedCostId: Long!) {
        bimcCalculationLimitedCostForUpdate(calculationId: $calculationId, limitedCostId: $limitedCostId) {
            data {
                id
                uniqueId
                calculationId
                catalogLimitedCostType {
                    id
                    name
                    uniqueId
                }
                catalogLimitedCostTypeId
                globalLimitedCostId
                chapter
                groupConstructionLimits {
                    constructionTypeId
                    calculatingValue
                }
                formula
                hasCalculatingParticipation
                isEditable
                isNorthernAllowance
                isManualLimitsDistribution
                key
                name
                rationale
                limits {
                    constructionTypeId
                    seasonId
                    cost
                }
                file {
                    count
                    dataUrl
                    name
                    size
                }
            }
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);
